import { forwardRef, memo, type ReactNode } from 'react';
import isBoolean from 'lodash/isBoolean';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
// Skillmore UI Components
import { fontWeightBold } from '@empathco/ui-components/src/styles/themeOptions';
import BoxTypography from '@empathco/ui-components/src/mixins/BoxTypography';

type JobDetailsItemProps = {
  readonly prompt: ReactNode;
  readonly value: boolean | ReactNode;
  readonly divider?: boolean;
}

const JobDetailsItem = forwardRef<HTMLElement, JobDetailsItemProps>(({
  prompt,
  value,
  divider = false
}, ref) => (
  <>
    <BoxTypography
        ref={ref}
        flex="1 1 auto"
        py={2}
        pl={2}
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent={{ xs: 'flex-start', sm: 'center' }}
        textAlign="center"
        variant="subtitle2"
    >
      <Box pr={2} fontWeight={fontWeightBold}>
        {prompt}
      </Box>
      <Box pr={2}>
        {isBoolean(value) ? <FormattedMessage id={value ? 'common.yes' : 'common.no'}/> : value}
      </Box>
    </BoxTypography>
    {divider ? (
      <Box alignSelf="stretch" py={1.5} display={{ xs: 'none', sm: 'block' }}>
        <Divider
            orientation="vertical"
            variant="middle"
        />
      </Box>
    ) : undefined}
  </>
));

JobDetailsItem.displayName = 'JobDetailsItem';

export default memo(JobDetailsItem);
